<template>
  <DashboardMobile v-if="$store.getters.isMobile" />
  <Dashboard v-else />
</template>

<script>
import DashboardMobile from "./DashboardMobile";
import Dashboard from "./Dashboard";

export default {
  name: "DashboardContainer",
  components: {
    DashboardMobile,
    Dashboard
  },
  created() {
    this.$store.commit("showSpinner");
    Promise.all([
      this.$store.dispatch("getUserInfo"),
      this.$store.dispatch("fetchNotifications"),
      this.$store.dispatch("fetchSuggestedCoinsReward"),
      this.$store.dispatch("fetchUserPoints"),
      this.$store.dispatch("fetchMissionsStatistics"),
      this.$store.dispatch("fetchUserMgms"),
      this.$store.dispatch("fetchLeaderboard"),
      this.$store.dispatch("getUserTasks")
    ]).finally(() => {
      this.$store.commit("hideSpinner");
    });
  }
};
</script>

<style></style>
